// extracted by mini-css-extract-plugin
module.exports = {"propertyLinks":"seo-links_propertyLinks__1yHeK","list":"seo-links_list__17hpe","listItem":"seo-links_listItem__1YR55"};